import { useEffect, useState } from "react";
import "@/App.css";
import Lenis from "lenis";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import AuthCallback from "@/components/landing/AuthCallback";
import PaymentResult from "@/components/landing/PaymentResult";
import Navbar from "@/components/landing/Navbar";
import Hero from "@/components/landing/Hero";
import TrustMarquee from "@/components/landing/TrustMarquee";
import Features from "@/components/landing/Features";
import Pricing from "@/components/landing/Pricing";
import DemoSection from "@/components/landing/DemoSection";
import Footer from "@/components/landing/Footer";
import ChatWidget from "@/components/landing/ChatWidget";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

function Landing() {
  const location = useLocation();
  const [user, setUser] = useState(location.state?.user || null);
  const [authChecked, setAuthChecked] = useState(!!location.state?.user);

  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  useEffect(() => {
    if (location.state?.user) return;
    // CRITICAL: If returning from OAuth callback, skip the /me check — AuthCallback handles it
    if (window.location.hash?.includes("session_id=")) return;
    (async () => {
      try {
        const res = await fetch(`${API}/auth/me`, { credentials: "include" });
        if (res.ok) setUser(await res.json());
      } catch {}
      setAuthChecked(true);
    })();
  }, [location.state]);

  const logout = async () => {
    try {
      await fetch(`${API}/auth/logout`, { method: "POST", credentials: "include" });
    } catch {}
    setUser(null);
  };

  return (
    <div className="min-h-screen bg-[#05060F] font-sans text-slate-100 antialiased">
      <div className="grain-overlay" aria-hidden="true" />
      <Navbar user={user} authChecked={authChecked} onLogout={logout} />
      <main>
        <Hero />
        <TrustMarquee />
        <Features />
        <DemoSection user={user} authChecked={authChecked} />
        <Pricing user={user} authChecked={authChecked} />
      </main>
      <Footer />
      <ChatWidget user={user} authChecked={authChecked} />
    </div>
  );
}

function AppRouter() {
  const location = useLocation();
  // Check URL fragment synchronously during render to prevent race conditions
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/payment/success" element={<PaymentResult variant="success" />} />
      <Route path="/payment/cancel" element={<PaymentResult variant="cancel" />} />
      <Route path="*" element={<Landing />} />
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AppRouter />
    </BrowserRouter>
  );
}

export default App;
